import {useResourcesToken, useTrackingServiceToken} from '@/di/di.root-container.hooks';

import {useState} from 'react';

import {useGameStatusStore} from '@/stores/connectors';
import {ButtonLink, ButtonLinkMods} from '@/ui/kit/ButtonLink/ButtonLink';

import {PDFModal} from '../PDFModal/PDFModal';

import s from './Footer.module.css';

export const Footer = (): JSX.Element => {
  const {
    content: {
      Footer: {title, links},
    },
  } = useResourcesToken();
  const trackingService = useTrackingServiceToken();
  const gameStatusStore = useGameStatusStore();

  const [activeLink, setActiveLink] = useState<{
    text: string;
    link: {smallVersion?: string; bigVersion: string};
  } | null>(null);

  const isShowLinks = !gameStatusStore.isStatusGameMocks();

  return (
    <>
      <footer className={s.footer}>
        {isShowLinks && (
          <ul className={s.links}>
            {links.map((link) => (
              <li key={link.text} className={s.link}>
                <ButtonLink
                  mod={ButtonLinkMods.LinkPrimary}
                  onClick={() => {
                    setActiveLink(link);
                    trackingService.trackClickToFooterLinks(link.text);
                  }}
                >
                  {link.text}
                </ButtonLink>
              </li>
            ))}
          </ul>
        )}

        <div className={s.copyrightWrapper}>
          {title.map((t, index) => (
            <p key={index} className={s.copyright}>
              {t}
            </p>
          ))}
        </div>
      </footer>
      {activeLink && (
        <PDFModal isOpen={true} title={activeLink.text} onClose={() => setActiveLink(null)} pdfUrl={activeLink.link} />
      )}
    </>
  );
};
